export default "__VITE_ASSET__DhCEjxDz__"